import { createAsyncThunk } from "@reduxjs/toolkit";
import apiInstance from "config/axiosInstance";

export const EditSettings = createAsyncThunk(
  "fieldSettings/EditSettings",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("fieldsettingCreate", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const ViewSettings = createAsyncThunk(
  "fieldSettings/ViewSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get("fieldsettingView");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
